<template>
  <v-card flat tile>
    <v-toolbar class="top-toolbar-content">
      <!-- <v-icon>fab fa-vuejs</v-icon> EXAMPLE font awesome -->
      <!-- <v-toolbar-title class="title"><span class="year">2021</span> Redistricting</v-toolbar-title> -->
      <a class="title-link" :href="rootLink()">
        <div class="title">
          <v-toolbar-title class="main-header"
            ><span class="year">Redistricting</span> &amp; You</v-toolbar-title
          >
          <!-- <v-toolbar-title class="subtitle">Current Districts &amp; Implications for Post-2020 Redistricting</v-toolbar-title> -->
          <v-toolbar-title class="subtitle"
            >Then-Current Districts &amp; Implications for Post-2020
            Maps</v-toolbar-title
          >
        </div>
      </a>
      <!-- Need "subhead" class -->
      <br />
      <v-row v-if="(!this.$store.getters.isMobile && !this.$store.getters.isEmbedded)" dense class="modal-btns">
        <Modal />
      </v-row>
      <!-- <MapTabs/> -->
      <v-spacer></v-spacer>

      <AddressSearch v-if="!this.$store.getters.isMobile" />

      <!-- 
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-toolbar>
    <div
      :class="[{ bottom: this.sideActive }, 'tap-more']"
      @click="toggleSideMenu()"
    >
      <span v-show="!this.sideActive" class="tap-txt">
        Tap here for more info
      </span>
      <span v-show="this.sideActive" class="tap-txt"> Go Back To Map </span>
      <v-icon color="white" v-show="!this.sideActive"
        >mdi-arrow-collapse-down</v-icon
      >
      <v-icon color="white" v-show="this.sideActive"
        >mdi-arrow-collapse-up</v-icon
      >
    </div>
  </v-card>
</template>
<script>
//import MapTabs from './MapTabs.vue'
import AddressSearch from "./Search/AddressSearch.vue";
//import { EventBus } from "../../data/EventBus";
import Modal from "./Modal/Modal.vue";

export default {
  name: "TopMenu",
  components: {
    // MapTabs
    AddressSearch,
    Modal,
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  watch: {},
  methods: {
    toggleSideMenu: function () {
      this.sideActive = !this.sideActive;
    },
    rootLink: function () {
      return window.location.origin + window.location.pathname;
    },
  },
  computed: {
    sideActive: {
      get: function () {
        return this.$store.getters.getSidePanelOpen;
      },
      set: function (newValue) {
        this.$store.commit("setSidePanelOpen", newValue);
      },
    },
  },
};
</script>
<style scoped>
.v-card {
  z-index: 3;
  height: 64px;
  caret-color: transparent;
}

.theme--light.v-toolbar.v-sheet {
  height: 64px;
}

.theme--light.v-toolbar.v-sheet .v-btn {
  background: var(--celadon-blue);
  border-radius: 0;
  width: 64px;
  height: 64px;
  color: var(--honeydew);
  margin-left: -16px !important;
}

.main-header {
  line-height: 1.125em;
}
.title-link {
  text-decoration: none;
}

.title-link .title {
  cursor: pointer !important;
}

.title {
  cursor: pointer;
  border-right: 1px solid lightgray;
  overflow: inherit;
  background: var(--powder-blue);
  /* background: var(--tan); */
  height: 64px;
  padding: 16px 64px;
  padding-left: 16px !important;
  color: var(--prussian-blue);
  font-weight: 900;
  text-transform: uppercase;
  cursor: default;
  /* margin-left: -16px;*/
  margin-left: -20px;
}

.title .year {
  color: var(--imperial-red);
}

.subtitle {
  font-size: 70%;
  text-transform: initial;
  font-weight: initial;
}
.v-tab--active {
  color: inherit;
}

header.top-toolbar-content {
  background: var(--honeydew) !important;
  /* background: var(--light-peach-puff) !important; */
}
.tap-more {
  display: none;
  padding: 2px;
}

.tap-more.bottom {
  position: fixed;
  left: 0;
  right: 0;
  top: auto;
  bottom: 0;
}

.tap-txt {
  height: 100%;
}


</style>